// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 206) return "static/chunks/206-628d4a82ae35dab6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"65":"8efd5537b620eb73","544":"b11db1de3875c077","581":"531bd2208b9bf793","923":"3f854b341053b564"}[chunkId] + ".js";
};